export const ROLES = {
  ADMIN: "admin",
  CUSTOMER: "customer",
};
